import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import SensorList from './pages/SensorList';
import SensorDetail from './pages/SensorDetail';
import PrivateRoute from './components/PrivateRoute';

// Importando CSS
import './pages/Auth.css';
import './pages/Dashboard.css';
import './pages/SensorList.css';
import './pages/SensorDetail.css';

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<PrivateRoute />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/sensors" element={<SensorList />} />
          <Route path="/sensors/:id" element={<SensorDetail />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
